export const NA = 'not applicable';
